import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import dynamic from 'next/dynamic';
const PhotoDownloadFreeMember = dynamic(() =>
  import('./PhotoDownloadFreeMember'),
);
const PhotoDownloadPremium = dynamic(() => import('./PhotoDownloadPremium'));
// import PhotoDownloadFreeMember from './PhotoDownloadFreeMember';
// import PhotoDownloadPremium from './PhotoDownloadPremium';
// import PhotoDownloadCreator from './PhotoDownloadCreator';
import {
  makeSelectProfile,
  selectAuth,
} from '~/containers/AuthProvider/selectors';
import Config from '~/config';

const roles = Config.getRoles();

class PhotoDownload extends React.Component {
  render() {
    const { auth, profile, onToggleSupportMessage, photo } = this.props;

    switch (profile.role) {
      case undefined:
      case roles.GUEST:
      case roles.FREE_MEMBER:
      case roles.CREATOR:
        return (
          <PhotoDownloadFreeMember
            role={profile.role}
            isAuthenticated={auth.isAuthenticated}
            photo={photo}
            onToggleSupportMessage={onToggleSupportMessage}
          />
        );
      case roles.PREMIUM:
        return (
          <PhotoDownloadPremium
            photo={photo}
            onToggleSupportMessage={onToggleSupportMessage}
            role={profile.role}
          />
        );
      default:
        return null;
    }
  }
}

const mapStateToProps = createStructuredSelector({
  auth: selectAuth,
  profile: makeSelectProfile(),
});
export default connect(mapStateToProps)(PhotoDownload);
